var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mounting-portal",
    {
      ref: "portal",
      attrs: { "mount-to": "#order-now-bar-target", append: "" },
    },
    [
      _c(
        "div",
        {
          ref: "orderNowWrapper",
          staticClass: "landingpage__order-now-wrapper",
        },
        [
          _c(
            "div",
            {
              staticClass: "landingpage__order-now-bar",
              class: { "landingpage__order-now-bar--sticky": _vm.isSticky },
            },
            [
              _c(
                "div",
                { staticClass: "wrapper" },
                [
                  _vm.landingPageData.price != null
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "server__meta__price d-flex align-items-start",
                          },
                          [
                            _vm.activeOrderConfiguration == null
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "button mr-3",
                                    attrs: {
                                      href: _vm.landingPageData.orderUrl,
                                    },
                                    on: { click: _vm.trackOrder },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.i18n.t(
                                            "general:non_special_texts.order"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _c("order-now-button", {
                                  staticClass: "mr-3",
                                  attrs: {
                                    units: _vm.activeOrderConfiguration.units,
                                    duration:
                                      _vm.activeOrderConfiguration.duration,
                                    "current-location":
                                      _vm.activeOrderConfiguration
                                        .currentLocation,
                                  },
                                }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "landingpage__order-now-bar__info",
                              },
                              [
                                _c(
                                  "transition",
                                  { attrs: { name: "slide-fade" } },
                                  [
                                    _vm.isSticky &&
                                    _vm.activeOrderConfiguration == null
                                      ? _c(
                                          "p",
                                          {
                                            key: "sticky-default-config",
                                            staticClass: "m-0",
                                          },
                                          [
                                            _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "server__meta__gametitle",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.landingPageData.title
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.landingPageData
                                                      .formattedPrice
                                                  ) +
                                                  "\n                    "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "price-gpc no-select",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.i18n.t(
                                                          "general:non_special_texts.per_unit",
                                                          {
                                                            unit: _vm.i18n.t(
                                                              _vm
                                                                .landingPageData
                                                                .cloudUnitType
                                                                .loco_key
                                                            ),
                                                          }
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm.isSticky &&
                                        _vm.activeOrderConfiguration != null
                                      ? _c(
                                          "p",
                                          {
                                            key:
                                              "sticky-order-config-" +
                                              _vm.activeOrderConfiguration
                                                .units +
                                              "-" +
                                              _vm.activeOrderConfiguration
                                                .duration,
                                            staticClass: "m-0",
                                          },
                                          [
                                            _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "server__meta__gametitle",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.landingPageData.title
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.i18n.t(
                                                      "landingpage:orderwidget.ram_price_per_day_per_gb",
                                                      {
                                                        formattedPrice:
                                                          _vm
                                                            .activeOrderConfiguration
                                                            .currentLocation
                                                            .formattedPrice,
                                                        duration:
                                                          _vm
                                                            .activeOrderConfiguration
                                                            .duration,
                                                        units:
                                                          _vm
                                                            .activeOrderConfiguration
                                                            .units,
                                                        unitName: _vm.i18n.t(
                                                          _vm.landingPageData
                                                            .cloudUnitType
                                                            .loco_key
                                                        ),
                                                      }
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : !_vm.isSticky &&
                                        _vm.activeOrderConfiguration == null
                                      ? _c(
                                          "p",
                                          {
                                            key: "static-default-config",
                                            staticClass: "m-0",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.landingPageData
                                                    .formattedPrice
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "price-gpc no-select",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.i18n.t(
                                                        "general:non_special_texts.per_unit",
                                                        {
                                                          unit: _vm.i18n.t(
                                                            _vm.landingPageData
                                                              .cloudUnitType
                                                              .loco_key
                                                          ),
                                                        }
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : !_vm.isSticky &&
                                        _vm.activeOrderConfiguration != null
                                      ? _c(
                                          "p",
                                          {
                                            key:
                                              "static-order-config-" +
                                              _vm.activeOrderConfiguration
                                                .units +
                                              "-" +
                                              _vm.activeOrderConfiguration
                                                .duration,
                                            staticClass: "m-0",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.activeOrderConfiguration
                                                    .currentLocation
                                                    .formattedPrice
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "price-gpc no-select",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.i18n.t(
                                                        "landingpage:orderwidget.per_day_per_unit",
                                                        {
                                                          duration:
                                                            _vm
                                                              .activeOrderConfiguration
                                                              .duration,
                                                          units:
                                                            _vm
                                                              .activeOrderConfiguration
                                                              .units,
                                                          unitName: _vm.i18n.t(
                                                            _vm.landingPageData
                                                              .cloudUnitType
                                                              .loco_key
                                                          ),
                                                        }
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _c(
                        "a",
                        {
                          staticClass: "button",
                          attrs: {
                            href: _vm.landingPageData.orderUrl,
                            target: "_blank",
                          },
                          on: { click: _vm.trackOrder },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.i18n.t("general:non_special_texts.order")
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                ],
                2
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }